import { UserRole } from 'shared/types/userRole';

export function isManager(role: UserRole): boolean {
  return role === UserRole.manager;
}
